var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
import Theme from '../Theme';
var breakpoints = Object.keys(Theme.breakpoints);
export var media = breakpoints.reduce(function (accumulator, label) {
    var emSize = Theme.breakpoints[label] / 16;
    accumulator[label] = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (min-width: ", "em) {\n      ", ";\n    }\n  "], ["\n    @media (min-width: ", "em) {\n      ", ";\n    }\n  "])), emSize, css.apply(void 0, params));
    };
    return accumulator;
}, {});
export var FONT_STRINGS = {
    Orleans: "var(--font-serif)",
    'Acta Display': "'Acta Display', 'Times New Roman', 'Times', serif",
    Inter: "var(--font-sans)",
    'Open Sans': "'Open Sans', sans-serif"
};
export var font = function (font) {
    if (font === void 0) { font = 'Inter'; }
    return function () {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-family: ", ";\n    "], ["\n      font-family: ", ";\n    "])), FONT_STRINGS[font]);
    };
};
export var triangle = function (_a) {
    var trianglePosition = _a.trianglePosition, borderColor = _a.borderColor, backgroundColor = _a.backgroundColor, size = _a.size, borderWidth = _a.borderWidth, placement = _a.placement;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: ", "px solid ", ";\n  &:after,\n  &:before {\n    ", ": 100%;\n    border: solid transparent;\n    content: ' ';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    ", "\n  }\n  &:after {\n    border-color: rgba(255, 255, 255, 0);\n    border-", "-color: ", ";\n    border-width: ", "px;\n    margin-", ": -", "px;\n  }\n  &:before {\n    border-color: rgba(231, 231, 231, 0);\n    border-", "-color: ", ";\n    border-width: ", "px;\n    margin-", ": 0px;\n  }\n"], ["\n  border: ", "px solid ", ";\n  &:after,\n  &:before {\n    ", ": 100%;\n    border: solid transparent;\n    content: ' ';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    ", "\n  }\n  &:after {\n    border-color: rgba(255, 255, 255, 0);\n    border-", "-color: ", ";\n    border-width: ", "px;\n    margin-", ": -", "px;\n  }\n  &:before {\n    border-color: rgba(231, 231, 231, 0);\n    border-", "-color: ", ";\n    border-width: ", "px;\n    margin-", ": 0px;\n  }\n"])), borderWidth, borderColor, placement, placement === 'left' || placement === 'right'
        ? "top: ".concat(trianglePosition)
        : "left: ".concat(trianglePosition), placement, backgroundColor, size, placement, borderWidth, placement, borderColor, size, placement);
};
export var container = function (size) {
    if (size === void 0) { size = 'regular'; }
    return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  padding: 2rem 1.5rem;\n  margin-right: auto;\n  margin-left: auto;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  width: 100%;\n  padding: 2rem 1.5rem;\n  margin-right: auto;\n  margin-left: auto;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), media.xsmall(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 4rem 0;\n    max-width: ", "px;\n  "], ["\n    padding: 4rem 0;\n    max-width: ", "px;\n  "])), size === 'small'
        ? Theme.breakpoints.xsmall * 0.9
        : Theme.breakpoints.xsmall), media.small(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    max-width: ", "px;\n  "], ["\n    max-width: ", "px;\n  "])), size === 'small' ? Theme.breakpoints.small * 0.9 : Theme.breakpoints.small), media.medium(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    max-width: ", "px;\n  "], ["\n    max-width: ", "px;\n  "])), size === 'small'
        ? Theme.breakpoints.medium * 0.9
        : Theme.breakpoints.medium), media.large(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    max-width: ", ";\n  "], ["\n    max-width: ", ";\n  "])), size === 'small'
        ? "calc(".concat(Theme.breakpoints.large * 0.9, "px - ").concat(Theme.sidebarWidth, ")")
        : "calc(".concat(Theme.breakpoints.large, "px - ").concat(Theme.sidebarWidth, ")")), media.xlarge(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    max-width: ", ";\n  "], ["\n    max-width: ", ";\n  "])), size === 'small'
        ? "calc(".concat(Theme.breakpoints.xlarge * 0.9, "px - ").concat(Theme.sidebarWidth, ")")
        : "calc(".concat(Theme.breakpoints.xlarge, "px - ").concat(Theme.sidebarWidth, ")")));
};
export var color = function (color) {
    if (color === void 0) { color = 'secondaryBrand'; }
    return function (props) {
        return props.theme.color[color];
    };
};
export var colorFromPalette = function (usage) {
    if (usage === void 0) { usage = 'background'; }
    return function (props) {
        return color(props.theme.palettes[props.color][usage])(props);
    };
};
export var borderRadius = function (borderRadius, whichCorners) {
    if (borderRadius === void 0) { borderRadius = 'regular'; }
    if (whichCorners === void 0) { whichCorners = ['top-left', 'top-right', 'bottom-left', 'bottom-right']; }
    return function (props) {
        return "border-top-left-radius: ".concat(whichCorners.includes('top-left')
            ? props.theme.borderRadius[borderRadius]
            : 0, ";\n  border-top-right-radius: ").concat(whichCorners.includes('top-right')
            ? props.theme.borderRadius[borderRadius]
            : 0, ";\n  border-bottom-right-radius: ").concat(whichCorners.includes('bottom-right')
            ? props.theme.borderRadius[borderRadius]
            : 0, ";\n  border-bottom-left-radius: ").concat(whichCorners.includes('bottom-left')
            ? props.theme.borderRadius[borderRadius]
            : 0, ";");
    };
};
export var fromTheme = function (fieldName) {
    return function (props) {
        return props.theme[fieldName];
    };
};
export var zIndex = function (elementName) { return function (props) {
    return props.theme.z[elementName];
}; };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=index.js.map